import { fetchWrapper } from "../utils/fetch-wrapper";

const actifsService = {
  getbyenv,
  getactifs,
  getNbActifs,
  getAll,
  gettAllExcept,
  getAllByClient,
  getAllNotVerified,
  getByUuid,
  getById,
  post,
  update,
  correspondanceActif,
  delete: _delete,
  archive_actif,
  dearchive_actif,
  archives_actifs,
  verifie_actif,
  getactifsliste,
  archives_actifs_byuser,
  getAllNotVerifiedUser,
  Renommer_actif,
  getActifsBySite,
  en_attente_actif,
  AssigneMembers,
};

function getAllByClient(env_client_id: any = "") {
  const queryParams: Record<string, any> = {};

  if (env_client_id !== "") {
    queryParams.user_id = env_client_id;
  }

  const queryString = Object.keys(queryParams)
    .map((key) => `${key}=${queryParams[key]}`)
    .join("&");

  return fetchWrapper.get(`actifs/?${queryString}`);
}


function getactifs(
  env_client_id: any = "",
  user_id: any = ""
) {
  const queryParams: Record<string, any> = {}
  if (env_client_id !== "") {
    queryParams.env_client_id = env_client_id;
  }
  if (user_id !== "") {
    queryParams.user_id = user_id;
  }
  const queryString = Object.keys(queryParams)
    .map((key) => `${key}=${queryParams[key]}`)
    .join("&");
  return fetchWrapper.get(`actifs/all?${queryString}`);
}







function getAll(
  interlocuteur_referent_id: any = "",
  status: any = "",
  chunkSize: any=0,
  societe_ids: any[] = [],
  individu_ids: any[] = [],
  env_client_id: any = "",
  currentPage: any=0,
  user_id: any = ""
) {
  const queryParams: Record<string, any> = {};

  if (interlocuteur_referent_id !== "") {
    queryParams.interlocuteur_referent_id = interlocuteur_referent_id;
  }

  if (status !== "") {
    queryParams.status = status;
  }
  if (societe_ids.length > 0) {
    queryParams.societe_ids = societe_ids.join("&societe_ids=");
  }
  if (individu_ids.length > 0) {
    queryParams.individu_ids = individu_ids.join("&individu_ids=");
  }
  if (env_client_id !== "") {
    queryParams.env_client_id = env_client_id;
  }

  if (user_id !== "") {
    queryParams.user_id = user_id;
  }
  queryParams.chunkSize = chunkSize; 
  queryParams.currentPage = currentPage;

  const queryString = Object.keys(queryParams)
    .map((key) => `${key}=${queryParams[key]}`)
    .join("&");
  return fetchWrapper.get(`actifs/?${queryString}`);
}

function gettAllExcept(client_id) {
  return fetchWrapper.get(`actifs/getall/except/${client_id}`);
}

function getbyenv(client_id) {
  return fetchWrapper.get(`actifs/getbyEnv/${client_id}`);
}

function getNbActifs(client_id) {
  return fetchWrapper.get(`actifs/getall/nb/${client_id}`);
}


function getAllNotVerifiedUser(user_id) {
  return fetchWrapper.get(`actifs/not_verified/${user_id}`);
}
function getAllNotVerified() {
  return fetchWrapper.get(`actifs/not_verified`);
}

function correspondanceActif(data) {
  return fetchWrapper.post(`actifs/correspondance`, data);
}

function getByUuid(
  uuid,
  format: any = "",
  bâtiment_id: any = "",
  niveau_id: any = "",
  espace_id: any = "",
  piece_id: any = ""
) {
  const queryParams: Record<string, any> = {};

  if (bâtiment_id !== "") {
    queryParams.bâtiment_id = bâtiment_id;
  }

  if (niveau_id !== "") {
    queryParams.niveau_id = niveau_id;
  }

  if (espace_id !== "") {
    queryParams.espace_id = espace_id;
  }

  if (piece_id !== "") {
    queryParams.piece_id = piece_id;
  }

  if (format !== "") {
    queryParams.format = format;
  }

  const queryString = Object.keys(queryParams)
    .map((key) => `${key}=${queryParams[key]}`)
    .join("&");

  return fetchWrapper.get(`actifs/${uuid}?${queryString}`);
}

function getById(id) {
  return fetchWrapper.get(`actifs/${id}`);
}

function getactifsliste(user_id) {
  return fetchWrapper.get(`actifs/liste/${user_id}`);
}

function post(formdata) {
  return fetchWrapper.post_formdata(`actifs/`, formdata);
}

function update(id, formdata) {
  return fetchWrapper.put_formdata(`actifs/${id}`, formdata);
}

function _delete(id) {
  return fetchWrapper.delete(`actifs/${id}`);
}

function archive_actif(id, params) {
  return fetchWrapper.put_hors_data(`actifs/archiver/${id}`, params);
}

function dearchive_actif(id, params) {
  return fetchWrapper.put_hors_data(`actifs/desarchive/${id}`, params);
}

function verifie_actif(id, params) {
  return fetchWrapper.put_hors_data(`actifs/verifie/${id}`, params);
}

function en_attente_actif(id, params) {
  return fetchWrapper.put_hors_data(`actifs/en_attente/${id}`, params);
}

function archives_actifs() {
  return fetchWrapper.get(`actifs/in_archive`);
}

function archives_actifs_byuser(actif_id) {
  return fetchWrapper.get(`actifs/in_archive/${actif_id}`);
}

function Renommer_actif(actif_id, data) {
  return fetchWrapper.put(`actifs/renommer/${actif_id}`, data);
}

function getActifsBySite(site_id) {
  return fetchWrapper.get(`actifs/by_site/${site_id}`);
}

function AssigneMembers(data) {
  return fetchWrapper.post(`actifs/assigne_members`, data);
}

export default actifsService;
